import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUpdateAdminsContentProps } from './msg-group-update-admins-content';
import { MsgGroupUpdateAdminsContent } from './msg-group-update-admins-content';

export interface MsgGroupUpdateAdminsProps extends MsgGroupUpdateAdminsContentProps {}

export const MsgGroupUpdateAdmins = memo(function MsgGroupUpdateAdmins({
  message,
}: MsgGroupUpdateAdminsProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUpdateAdminsContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
